export let tableHead = [
  {
    prop: "xh",
    label: "序号",
    handle: "index",
    width: 50,
    textAlign: "center",
    fixed: "left" 
  },
  { label: "条码", prop: "barCode", fixed: "left",  minWidth: 160 },

  { label: "生产线", prop: "workLine", textAlign: "center", },
  { label: "加工年度", prop: "workYear", textAlign: "center", },
  { label: "设备编号", prop: "deviceNo", minWidth: 200 },
  { label: "样批号", prop: "sampleCode", textAlign: "center", },
  { label: "包号", prop: "packetCode", textAlign: "center", },
  { label: "籽棉等级", prop: "seedLevel", textAlign: "center", },
  
  { label: "毛重", prop: "grossWeight", textAlign: "center", },
  { label: "净重", prop: "netWeight", textAlign: "center", },
  { label: "皮重", prop: "tareWeight", textAlign: "center", },
  { label: "回潮率", prop: "moistureRate", textAlign: "center", },

  { label: "上传时间", prop: "uploadTime", textAlign: "center", minWidth: 160,
   /* formatter: (row, column, cellValue) => {
      if (!cellValue) return ''
      return cellValue.substring(0,10)
    }*/
  },
  { label: "上传人", prop: "uploadUser", textAlign: "center", },
  { label: "上传状态", prop: "uploadStatusText", textAlign: "center",  },
  { label: "上传失败原因", prop: "uploadFailReason", textAlign: "center", minWidth: 160 },

  { label: "采集时间", prop: "acquisitionTime", textAlign: "center", },
  { label: "加工类型", prop: "processTypeText", textAlign: "center", },
  { label: "异性纤维", prop: "foreFiberText", textAlign: "center", },
  { label: "班次信息", prop: "classCode", textAlign: "center", },
  { label: "加工日期", prop: "workDate", textAlign: "center",  minWidth: 110,
    formatter: (row, column, cellValue) => {
      if (!cellValue) return ''
      return cellValue.substring(0,10)
    }
  },
  { label: "加工检验组批号", prop: "batchCode", textAlign: "center", minWidth: 120 },
  { label: "垛位号", prop: "pileNo", textAlign: "center", },
  { label: "棉花品种", prop: "cottonType", textAlign: "center", },
  { label: "班长", prop: "monitor", textAlign: "center", },
  { label: "籽棉颜色级", prop: "seedColorLevel", textAlign: "center", minWidth: 110 },
  { label: "采集器类型", prop: "machineType", textAlign: "center", minWidth: 110 },
  { label: "追溯卡号1", prop: "mold1", textAlign: "center", },
  { label: "追溯卡号2", prop: "mold2", textAlign: "center", },
  { label: "追溯卡号3", prop: "mold3", textAlign: "center", },
  { label: "追溯卡号4", prop: "mold4", textAlign: "center", },
  { label: "卷标号", prop: "volumeLabel", textAlign: "center", minWidth: 120},
  { label: "刷唛批号", prop: "brushNo", textAlign: "center", minWidth: 120 },
  { label: "喇啧模式", prop: "latchesMode", textAlign: "center",  },
  {
    prop: "cz",
    label: "操作",
    handle: "btns",
    textAlign: "center",
    width: 80,
    fixed: "right",
  },
];
